import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class vCityBase {

//#region stateName Prop
        @gridColumn({visible: true, columnIndex:2, allowSorting: true, headerKey: 'stateName', keyColumn: false, headerTitle: "State"})
        stateName : string;
//#endregion stateName Prop


//#region countryName Prop
        @gridColumn({visible: true, columnIndex:3, allowSorting: true, headerKey: 'countryName', keyColumn: false, headerTitle: "Country"})
        countryName : string;
//#endregion countryName Prop


//#region cityId Prop
        @gridColumn({visible: false, columnIndex:0, allowSorting: true, headerKey: 'cityId', keyColumn: true})
        cityId : number;
//#endregion cityId Prop


//#region cityName Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'cityName', keyColumn: false, headerTitle: "City"})
        cityName : string;
//#endregion cityName Prop


//#region status Prop
        @gridColumn({visible: true, columnIndex:4, allowSorting: true, headerKey: 'status', keyColumn: false, headerTitle: "Status", configuredTemplate: { templateName: "recordActive" }})
        status : string;
//#endregion status Prop

}